import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { getTagColorKey } from '@/shared/components/tag/tagColors';

const messages = defineMessages({
  RemoveTag: 'Remove tag',
});

class Tag extends React.PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    item: PropTypes.shape({
      value: PropTypes.object.isRequired,
    }),
    title: PropTypes.string,
    removeTitle: PropTypes.string,
    onRemove: PropTypes.func,
    color: PropTypes.number,
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    onRemove: () => {},
    item: undefined,
    title: null,
    removeTitle: null,
    color: undefined,
    readOnly: false,
  };

  onRemove = e => {
    const { onRemove, item } = this.props;

    e.preventDefault();
    e.stopPropagation();
    if (onRemove) {
      onRemove({ ...item });
    }
  };

  render() {
    const { intl, item, title, removeTitle, color, readOnly } = this.props;
    return (
      <span
        className={classNames('document-tag', {
          [`tag-color-${getTagColorKey(color)}`]: color !== undefined,
        })}
        title={title}
      >
        {item.name}
        {!readOnly && (
          <i
            className="fa fa-times margin5L"
            aria-hidden="true"
            onClick={this.onRemove}
            title={removeTitle || intl.formatMessage(messages.RemoveTag)}
          />
        )}
      </span>
    );
  }
}

export default injectIntl(Tag);
